(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/extra-game-info.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/extra-game-info.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  useContext = _React.useContext,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const formatCurrency = svs.utils.format.Currency;
const _svs$utils$date = svs.utils.date,
  getLocalizedWeekday = _svs$utils$date.getLocalizedWeekday,
  formatTime = _svs$utils$date.FormatTime;
const _svs$numbergames = svs.numbergames,
  productMapping = _svs$numbergames.productMapping,
  rules = _svs$numbergames.rules;
const drawsApi = svs.numbergames.draws.drawsApi;
const containerStates = svs.numbergames.fractiongames.constants.containerStates;
const CampaignInfo = svs.numbergames.fractiongames.components.gamecard.CampaignInfo;
const ContainerContext = svs.numbergames.fractiongames.contexts.ContainerContext;
const ExtraGameInfo = () => {
  const _useContext = useContext(ContainerContext),
    selectors = _useContext.selectors;
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const game = useSelector(selectors.selectGame);
  const buyinCloseTime = useSelector(selectors.selectBuyinCloseTime);
  const sharePrice = useSelector(selectors.selectSharePrice);
  const totalPrice = useSelector(selectors.selectTotalPrice);
  const totalShares = useSelector(selectors.selectTotalShares);
  const containerState = useSelector(selectors.selectContainerState);
  const gameInfo = useMemo(() => {
    const Kopstopp = 'Köpstopp';
    const NastaKopstopp = 'Nästa köpstopp';
    const currentRegCloseTime = drawsApi.currentRegCloseTime(productNumeric);
    const nextRegCloseTime = drawsApi.nextRegCloseTime(productNumeric);
    const systemDescription = () => {
      var _game$systemSize, _game$systemSize2;
      return rules.system.systemName({
        numbersLength: (_game$systemSize = game.systemSize) === null || _game$systemSize === void 0 ? void 0 : _game$systemSize.numbersSize,
        numbersExtraLength: (_game$systemSize2 = game.systemSize) === null || _game$systemSize2 === void 0 ? void 0 : _game$systemSize2.extraNumbersSize,
        level: game.level
      });
    };
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      [game.isSystemBoard ? systemDescription() : 'Antal rader']: "".concat(game.rowCount, " rader")
    }, productMapping.isKeno(productNumeric) && {
      'Kung Keno': game.hasKungKeno ? "".concat(formatCurrency(game.rowPrice * game.rowPriceMulti), " kr/rad") : 'Nej'
    }), productMapping.hasJoker(productNumeric) && {
      Joker: game.jokerPrice ? "".concat(formatCurrency(game.jokerPrice), " kr") : 'Nej'
    }), {}, {
      'Pris totalt': "".concat(formatCurrency(totalPrice), " kr"),
      'Antal andelar': "".concat(totalShares, " st"),
      'Pris per andel': "".concat(formatCurrency(sharePrice), " kr")
    }, containerState === containerStates.CONTAINER_OPEN && {
      [Kopstopp]: buyinCloseTime ? "".concat(getLocalizedWeekday(buyinCloseTime), " kl. ").concat(formatTime('HH:mm', buyinCloseTime)) : ''
    }), containerState === containerStates.GAME_SOLD_OUT && {
      [Kopstopp]: currentRegCloseTime ? getLocalizedWeekday(currentRegCloseTime) : ''
    }), containerState === containerStates.CONTAINER_CLOSED && {
      [NastaKopstopp]: nextRegCloseTime ? getLocalizedWeekday(nextRegCloseTime) : ''
    }), productMapping.isDaySpecificId(productNumeric) && {
      Dragningsdag: productMapping.getDay(productNumeric)
    });
  }, [containerState, buyinCloseTime, game, productNumeric, sharePrice, totalPrice, totalShares]);
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "ng-fg-row-info"
  }, game.isSystemBoard ? 'Raderna skapas via ett systemspel där numren slumpas. Antalet nummer avgör systemets storlek och antal rader.' : 'Alla rader skapas individuellt med slumpade nummer.'), productMapping.isLotto(productNumeric) && React.createElement("p", {
    className: "ng-fg-lotto-row-info"
  }, "Lotto 1 & 2 med Joker"), React.createElement(CampaignInfo, null), React.createElement("div", {
    className: "ng-fg-card-extra-info"
  }, React.createElement("hr", {
    className: "ng-fg-hr margin-top-0"
  }), Object.entries(gameInfo).map(_ref => {
    let _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return React.createElement("p", {
      key: key
    }, React.createElement("span", null, key, ": "), " ", value);
  }), React.createElement("hr", {
    className: "ng-fg-hr"
  }), React.createElement("p", {
    className: "fg-extra-info-game-closed"
  }, "Om inte alla andelar s\xE5lts vid k\xF6pstopp f\xF6rs pengarna tillbaka till ditt spelkonto d\xE5 spelet annulleras.")));
};
svs.numbergames.fractiongames.components.gamecard.ExtraGameInfo = ExtraGameInfo;

 })(window);